import React from 'react';

import { H3Styled } from './H3.style';

export const H3 = ({ children, ...props }: { children: any }) => {
  return <H3Styled {...props}>{children}</H3Styled>;
};
